var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.currentOptStatus !== _vm.optStatusDefs.billDetailView &&
                _vm.currentOptStatus !== _vm.optStatusDefs.newBillDetailView,
              expression:
                "currentOptStatus!==optStatusDefs.billDetailView && currentOptStatus!==optStatusDefs.newBillDetailView"
            }
          ],
          staticClass: "main-content"
        },
        [
          _c(
            "search-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.billType === "charge",
                  expression: "billType==='charge'"
                }
              ],
              key: "1",
              ref: "searchItem1",
              attrs: {
                "is-append-query": true,
                "show-more-scheme": true,
                "show-simple": true,
                "expand-adv": true,
                "search-item-code": _vm.$t("Clearing.ReconciliationByFee"),
                "config-module": "5031",
                "grid-config-module": "190901",
                "auto-init": false,
                "custom-search-items": _vm.chargeCustomSearchItems,
                "custom-sim-query-placeholder": _vm.$t(
                  "Clearing.QuickSearchBusinessNumber"
                ),
                disabled: _vm.currentOptStatus === _vm.optStatusDefs.checking
              },
              on: {
                query: _vm.fetchData,
                advToggle: _vm.scrollCallback,
                perConfigChange: function(value) {
                  _vm.chargePerConfigName = value
                },
                refreshGrid: function() {
                  _vm.chargeGridRefreshId += 1
                },
                defaultSearchItemsChange: function(value) {
                  _vm.chargeDefaultSearchItems = value
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "searchAreaHeader",
                  fn: function() {
                    return [
                      _c("extension-conditions", {
                        key: "11",
                        ref: "chargeExtCond",
                        attrs: {
                          no: "20",
                          conditions: _vm.defaultSearchConditions,
                          "bill-type": _vm.billType,
                          "enabled-bill-type":
                            _vm.currentOptStatus === _vm.optStatusDefs.checking,
                          source: "reconciliationByJob"
                        },
                        on: {
                          "update:billType": function($event) {
                            _vm.billType = $event
                          },
                          "update:bill-type": function($event) {
                            _vm.billType = $event
                          }
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c("template", { slot: "operations" }, [
                _vm.currentOptStatus === _vm.optStatusDefs.normal
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "1" },
                            on: {
                              click: function($event) {
                                return _vm.createBillingEvent(null)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CreateBill")))]
                        ),
                        _vm.role.confirmCharges
                          ? _c(
                              "el-dropdown",
                              {
                                staticStyle: { margin: "0 5px" },
                                attrs: {
                                  "split-button": "",
                                  type: "primary",
                                  no: "2"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.commandHandle()
                                  },
                                  command: function(p) {
                                    _vm.command1 = p
                                    _vm.commandHandle()
                                  }
                                }
                              },
                              [
                                _vm._v(" " + _vm._s(_vm.command1) + " "),
                                _c(
                                  "el-dropdown-menu",
                                  {
                                    attrs: { slot: "dropdown" },
                                    slot: "dropdown"
                                  },
                                  [
                                    _c(
                                      "el-dropdown-item",
                                      {
                                        attrs: {
                                          command: _vm.$t(
                                            "CargoMsg.Cargo_StartReconciliation"
                                          )
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "CargoMsg.Cargo_StartReconciliation"
                                            )
                                          )
                                        )
                                      ]
                                    ),
                                    _vm.$checkPermission([
                                      "button_ACTBilling_AutomaticReconciliation"
                                    ])
                                      ? _c(
                                          "el-dropdown-item",
                                          {
                                            attrs: {
                                              command: _vm.$t(
                                                "CargoMsg.AutomaticReconciliation"
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "CargoMsg.AutomaticReconciliation"
                                                )
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.$checkPermission([
                                      "button_ACTBilling_AutomaticReconciliation"
                                    ])
                                      ? _c(
                                          "el-dropdown-item",
                                          {
                                            attrs: {
                                              command: _vm.$t(
                                                "CargoMsg.CheckHistory"
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t("CargoMsg.CheckHistory")
                                              )
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.role.createInvoiceFromCharges ||
                        _vm.role.createInvoiceFromApCharges
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "3" },
                                on: { click: _vm.makeInvoiceEvent }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_IssuanceReceiptOfInvoice"
                                    )
                                  ) + " "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.role.writeoffCharges
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "4" },
                                on: { click: _vm.writeoffHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_WriteOff"))
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.role.payauthFromCharges
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "5" },
                                on: { click: _vm.doBillPayment }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("CargoMsg.Cargo_ApplyForPayment")
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !_vm.isJobBillType && _vm.chargeAuditFlow,
                                expression: "!isJobBillType && chargeAuditFlow"
                              }
                            ],
                            attrs: { type: "primary", no: "6" },
                            on: { click: _vm.auditEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_ChargesAudit"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !_vm.isJobBillType && _vm.chargeAuditFlow,
                                expression: "!isJobBillType && chargeAuditFlow"
                              }
                            ],
                            attrs: { type: "primary", no: "7" },
                            on: { click: _vm.auditCancelEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_CancelAudit")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !_vm.isJobBillType && _vm.chargeAuditFlow,
                                expression: "!isJobBillType && chargeAuditFlow"
                              }
                            ],
                            attrs: { type: "primary", no: "8" },
                            on: { click: _vm.rejectEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_ChargesReject"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !_vm.isJobBillType &&
                                  _vm.showBatchGenerateBillingBtn,
                                expression:
                                  "!isJobBillType && showBatchGenerateBillingBtn"
                              }
                            ],
                            attrs: { type: "primary", no: "9" },
                            on: { click: _vm.batchGenerateBilling }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_BatchCreateBill"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.chargeSubmitDirect &&
                                  _vm.submitChargeRole,
                                expression:
                                  "chargeSubmitDirect && submitChargeRole"
                              }
                            ],
                            attrs: { type: "primary", no: "10" },
                            on: {
                              click: function($event) {
                                return _vm.submitEventHandler(true)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Billing.chargeList_submission"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.chargeSubmitDirect &&
                                  _vm.cancelSubmitChargeRole,
                                expression:
                                  "chargeSubmitDirect && cancelSubmitChargeRole"
                              }
                            ],
                            attrs: { type: "primary", no: "11" },
                            on: {
                              click: function($event) {
                                return _vm.submitEventHandler(false)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Billing.chargeList_cancelSubmit"))
                            )
                          ]
                        ),
                        _vm.role.auditCharge
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "12" },
                                on: {
                                  click: function($event) {
                                    return _vm.chargeAuditOrCancelAudit(true)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Audit")))]
                            )
                          : _vm._e(),
                        _vm.role.cancelAuditCharge
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "13" },
                                on: {
                                  click: function($event) {
                                    return _vm.chargeAuditOrCancelAudit(false)
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_CancelAudit"))
                                )
                              ]
                            )
                          : _vm._e(),
                        !_vm.isJobBillType &&
                        _vm.role.batchUpdateConfirmSerialNumber &&
                        _vm.openBatchUpdateConfirmSerialNumber
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "14" },
                                on: {
                                  click: _vm.batchUpdateConfirmSerialNumber
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_BatchUpdateChargeConfirmSerialNumber"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        !_vm.isJobBillType && _vm.hmToFinanceApi
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "15" },
                                on: { click: _vm.toManualSyncHM }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("Clearing.ManualSynchronization")
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.role.batchUpload
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "batchUpload" },
                                on: { click: _vm.batchUploadFileHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_BatchUploadFile")
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-dropdown",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: !_vm.isJobBillType,
                                expression: "!isJobBillType"
                              }
                            ],
                            staticStyle: { margin: "0 5px" },
                            attrs: { trigger: "hover", no: "batchProcess" },
                            on: { command: _vm.batchProcessHandler }
                          },
                          [
                            _c("el-button", { attrs: { type: "primary" } }, [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("CargoMsg.Cargo_BatchProcess"))
                              ),
                              _c("i", {
                                staticClass: "el-icon-arrow-down el-icon--right"
                              })
                            ]),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { command: "changeAccountId" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_ChangeSettlement"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-dropdown-item",
                                  { attrs: { command: "changeInvoiceTitle" } },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Partners.modifyInvoicingHeader")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm.$checkPermission([
                          "button_ACTBilling_reconciliationInvoicePool"
                        ]) && !_vm.chargeIsAr
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  no: "showInvoicePoolDialog"
                                },
                                on: { click: _vm.showInvoicePoolDialog }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_InvoicePoolReceiving"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.operateReviewRemarkDialog.visible
                          ? _c(
                              "el-button",
                              {
                                attrs: { no: "reviewRemarks", type: "primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.reviewRemarks()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.reviewTitle) + " ")]
                            )
                          : _vm._e(),
                        _vm.financialRemarksDialog.visible
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "financialRemarks",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.financialRemarks()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.financialRemarksTitle) + " ")]
                            )
                          : _vm._e(),
                        _vm.confirmationLetterRemarksDialog.visible
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "confirmationLetterRemarks",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.confirmationLetterRemarks()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.confirmationLetterRemarksTitle) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentOptStatus === _vm.optStatusDefs.reviewRemarks
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "42" },
                            on: {
                              click: function($event) {
                                return _vm.cancelReviewRemarks()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", no: "43" },
                            on: {
                              click: function($event) {
                                return _vm.saveReviewRemarks()
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentOptStatus === _vm.optStatusDefs.checking
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "15" },
                            on: { click: _vm.cancelReconciliationBill }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_CancelReconciliation")
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", no: "16" },
                            on: { click: _vm.saveReconciliationEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_SaveReconciliation")
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "17" },
                            on: { click: _vm.processDiffAmountEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_ProcessingDifference")
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "18" },
                            on: { click: _vm.batchConfirmEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_BatchConfirm"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "19" },
                            on: { click: _vm.batchCancelConfirmEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_CancelConfirm"))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            2
          ),
          _c(
            "search-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.billType === "job",
                  expression: "billType==='job'"
                }
              ],
              key: "2",
              ref: "searchItem2",
              attrs: {
                "is-append-query": true,
                "show-more-scheme": true,
                "show-simple": true,
                "expand-adv": true,
                "search-item-code": _vm.$t("Clearing.ReconciliationByBusiness"),
                "config-module": "5032",
                "grid-config-module": "190902",
                "auto-init": false,
                "custom-search-items": _vm.jobCustomSearchItems,
                "custom-sim-query-placeholder": _vm.$t(
                  "Clearing.QuickSearchBusinessNumber"
                ),
                disabled: _vm.currentOptStatus === _vm.optStatusDefs.checking
              },
              on: {
                query: _vm.fetchData,
                advToggle: _vm.scrollCallback,
                perConfigChange: function(value) {
                  _vm.jobPerConfigName = value
                },
                refreshGrid: function() {
                  _vm.jobGridRefreshId += 1
                },
                defaultSearchItemsChange: function(value) {
                  _vm.jobDefaultSearchItems = value
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "searchAreaHeader",
                  fn: function() {
                    return [
                      _c("extension-conditions", {
                        key: "12",
                        ref: "jobExtCond",
                        attrs: {
                          conditions: _vm.defaultSearchConditions,
                          "bill-type": _vm.billType,
                          "enabled-bill-type":
                            _vm.currentOptStatus === _vm.optStatusDefs.checking,
                          source: "reconciliationByCharge"
                        },
                        on: {
                          "update:billType": function($event) {
                            _vm.billType = $event
                          },
                          "update:bill-type": function($event) {
                            _vm.billType = $event
                          }
                        }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _c("template", { slot: "operations" }, [
                _vm.currentOptStatus === _vm.optStatusDefs.normal
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "21" },
                            on: {
                              click: function($event) {
                                return _vm.createBillingEvent(null)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CreateBill")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_ACTBilling_confirmCharges"],
                                expression:
                                  "['button_ACTBilling_confirmCharges']"
                              }
                            ],
                            attrs: { type: "primary", no: "22" },
                            on: { click: _vm.startReconciliationBill }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_StartReconciliation")
                              )
                            )
                          ]
                        ),
                        _vm.role.createInvoiceFromCharges ||
                        _vm.role.createInvoiceFromApCharges
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "23" },
                                on: { click: _vm.makeInvoiceEvent }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_IssuanceReceiptOfInvoice"
                                    )
                                  ) + " "
                                )
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_ACTBilling_writeoffCharges"],
                                expression:
                                  "['button_ACTBilling_writeoffCharges']"
                              }
                            ],
                            attrs: { type: "primary", no: "24" },
                            on: { click: _vm.writeoffHandler }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_WriteOff")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_ACTBilling_payauthFromCharges"],
                                expression:
                                  "['button_ACTBilling_payauthFromCharges']"
                              }
                            ],
                            attrs: { type: "primary", no: "25" },
                            on: { click: _vm.doBillPayment }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("CargoMsg.Cargo_ApplyForPayment")
                                ) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !_vm.isJobBillType && _vm.chargeAuditFlow,
                                expression: "!isJobBillType && chargeAuditFlow"
                              }
                            ],
                            attrs: { type: "primary", no: "26" },
                            on: { click: _vm.auditEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_ChargesAudit"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !_vm.isJobBillType && _vm.chargeAuditFlow,
                                expression: "!isJobBillType && chargeAuditFlow"
                              }
                            ],
                            attrs: { type: "primary", no: "27" },
                            on: { click: _vm.auditCancelEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_CancelAudit")) + " "
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  !_vm.isJobBillType && _vm.chargeAuditFlow,
                                expression: "!isJobBillType && chargeAuditFlow"
                              }
                            ],
                            attrs: { type: "primary", no: "28" },
                            on: { click: _vm.rejectEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_ChargesReject"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.chargeSubmitDirect &&
                                  _vm.submitChargeRole,
                                expression:
                                  "chargeSubmitDirect && submitChargeRole"
                              }
                            ],
                            attrs: { type: "primary", no: "29" },
                            on: {
                              click: function($event) {
                                return _vm.submitEventHandler(true)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Billing.chargeList_submission"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.chargeSubmitDirect &&
                                  _vm.cancelSubmitChargeRole,
                                expression:
                                  "chargeSubmitDirect && cancelSubmitChargeRole"
                              }
                            ],
                            attrs: { type: "primary", no: "30" },
                            on: {
                              click: function($event) {
                                return _vm.submitEventHandler(false)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("Billing.chargeList_cancelSubmit"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_ACTBilling_auditCharge"],
                                expression: "['button_ACTBilling_auditCharge']"
                              }
                            ],
                            attrs: { type: "primary", no: "31" },
                            on: {
                              click: function($event) {
                                return _vm.chargeAuditOrCancelAudit(true)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Audit")))]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: ["button_ACTBilling_cancelAuditCharge"],
                                expression:
                                  "['button_ACTBilling_cancelAuditCharge']"
                              }
                            ],
                            attrs: { type: "primary", no: "32" },
                            on: {
                              click: function($event) {
                                return _vm.chargeAuditOrCancelAudit(false)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CancelAudit")))]
                        ),
                        _vm.role.batchUpload
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "primary", no: "batchUpload" },
                                on: { click: _vm.batchUploadFileHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_BatchUploadFile")
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.$checkPermission([
                          "button_ACTBilling_reconciliationInvoicePool"
                        ]) && !_vm.jobIsAr
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  no: "showInvoicePoolDialog"
                                },
                                on: { click: _vm.showInvoicePoolDialog }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_InvoicePoolReceiving"
                                    )
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm.financialRemarksDialog.visible
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "financialRemarks",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.financialRemarks()
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.financialRemarksTitle) + " ")]
                            )
                          : _vm._e(),
                        _vm.confirmationLetterRemarksDialog.visible
                          ? _c(
                              "el-button",
                              {
                                attrs: {
                                  no: "confirmationLetterRemarks",
                                  type: "primary"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.confirmationLetterRemarks()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.confirmationLetterRemarksTitle) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.currentOptStatus === _vm.optStatusDefs.checking
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "33" },
                            on: { click: _vm.cancelReconciliationBill }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_CancelReconciliation")
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", no: "34" },
                            on: { click: _vm.saveReconciliationEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_SaveReconciliation")
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "35" },
                            on: { click: _vm.processDiffAmountEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("CargoMsg.Cargo_ProcessingDifference")
                              )
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "36" },
                            on: { click: _vm.batchConfirmEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_BatchConfirm"))
                            )
                          ]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", no: "37" },
                            on: { click: _vm.batchCancelConfirmEvent }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.$t("CargoMsg.Cargo_CancelConfirm"))
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ],
            2
          ),
          _vm.billType === "job"
            ? _c(
                "div",
                { key: "job", staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid-wrapper", {
                    key: 1,
                    attrs: {
                      "config-module": "190902",
                      "per-config-name": _vm.jobPerConfigName,
                      "refresh-id": _vm.jobGridRefreshId,
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.dynamicColumnDefs,
                      "sum-column-defs": _vm.sumColumnDefsComputed,
                      "total-config": _vm.totalConfig,
                      "row-data": _vm.rowData,
                      "show-row-groups": _vm.dataListDragGroup,
                      "pre-column-state-callback": _vm.preColumnStateCallback
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.billType === "charge"
            ? _c(
                "div",
                { key: "charge", staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid-wrapper", {
                    attrs: {
                      "config-module": "190901",
                      "per-config-name": _vm.chargePerConfigName,
                      "refresh-id": _vm.chargeGridRefreshId,
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.dynamicColumnDefs,
                      "sum-column-defs": _vm.sumColumnDefsComputed,
                      "total-config": _vm.totalConfig,
                      "row-data": _vm.rowData,
                      "show-row-groups": _vm.dataListDragGroup,
                      "pre-column-state-callback": _vm.preColumnStateCallback
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      }
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "pagination-wrapper",
              attrs: { id: "footer-wrapper" }
            },
            [
              _c(
                "div",
                {
                  class: [_vm.shouldFixed ? "fixedBottom" : ""],
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-end",
                    "flex-wrap": "wrap"
                  }
                },
                [
                  _c("div", [
                    _c("span", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.dataShow && _vm.totalAmountToCurrency.labelText,
                          expression:
                            "dataShow && totalAmountToCurrency.labelText"
                        }
                      ],
                      staticStyle: {
                        "font-weight": "bold",
                        "font-size": "13px"
                      },
                      domProps: {
                        textContent: _vm._s(_vm.totalAmountToCurrency.labelText)
                      }
                    }),
                    _c("span", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.dataShow,
                          expression: "dataShow"
                        }
                      ],
                      staticStyle: { "font-size": "12px" },
                      domProps: { textContent: _vm._s(_vm.selectionCountLabel) }
                    })
                  ]),
                  _c("div", [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.dataShow && _vm.ticketCount > 0,
                            expression: "dataShow && ticketCount > 0"
                          }
                        ],
                        staticStyle: {
                          "font-weight": "bold",
                          "font-size": "13px"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_TicketCount")))]
                    ),
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.dataShow && _vm.ticketCount > 0,
                            expression: "dataShow && ticketCount > 0"
                          }
                        ],
                        staticStyle: { "font-size": "12px" }
                      },
                      [_vm._v(_vm._s(_vm.ticketCount))]
                    )
                  ]),
                  _c(
                    "div",
                    [
                      _c("charge-currency-total-group", {
                        key: 1,
                        ref: "chargeCurrencyTotalGroup1",
                        attrs: {
                          "amount-to-currency": "",
                          mode: "group",
                          type: _vm.totalAmountToCurrency.type,
                          "data-provider":
                            _vm.totalAmountToCurrency.dataProvider,
                          "data-field": _vm.totalAmountToCurrency.dataField,
                          "currency-field":
                            _vm.totalAmountToCurrency.currencyField,
                          "rate-field": _vm.totalAmountToCurrency.rateField,
                          "arap-group": _vm.totalAmountToCurrency.arapGroup,
                          "show-wht": _vm.showWhtTax,
                          "ar-field": "chargeReceivable"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.showSalePriceHc,
                          expression: "!showSalePriceHc"
                        }
                      ]
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.dataShow &&
                                _vm.rowData &&
                                _vm.rowData.length > 0,
                              expression:
                                "dataShow && rowData && rowData.length > 0"
                            }
                          ]
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_ReconciliationAmount")
                            )
                          )
                        ]
                      ),
                      _c("charge-currency-total-group", {
                        key: 2,
                        ref: "chargeCurrencyTotalGroup2",
                        attrs: {
                          "amount-to-currency": "",
                          mode: "group",
                          type: _vm.totalAmountToCurrency.type,
                          "data-provider":
                            _vm.totalAmountToCurrency.dataProvider,
                          "data-field": "chargeBillingAmount",
                          "currency-field":
                            _vm.totalAmountToCurrency.currencyField,
                          "rate-field": _vm.totalAmountToCurrency.rateField,
                          "arap-group": _vm.totalAmountToCurrency.arapGroup,
                          "ar-field": "chargeReceivable"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.showSalePriceHc,
                          expression: "!showSalePriceHc"
                        }
                      ]
                    },
                    [
                      _c(
                        "span",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.dataShow &&
                                _vm.rowData &&
                                _vm.rowData.length > 0,
                              expression:
                                "dataShow && rowData && rowData.length > 0"
                            }
                          ]
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Difference")))]
                      ),
                      _c("charge-currency-total-group", {
                        key: 3,
                        ref: "chargeCurrencyTotalGroup3",
                        attrs: {
                          "amount-to-currency": "",
                          mode: "group",
                          type: _vm.totalAmountToCurrency.type,
                          "data-provider":
                            _vm.totalAmountToCurrency.dataProvider,
                          "data-field": "chargeDiffAmount",
                          "currency-field":
                            _vm.totalAmountToCurrency.currencyField,
                          "rate-field": _vm.totalAmountToCurrency.rateField,
                          "arap-group": _vm.totalAmountToCurrency.arapGroup,
                          "ar-field": "chargeReceivable"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            key: 4,
                            ref: "chargeCurrencyTotalGroup3",
                            attrs: {
                              "amount-to-currency": _vm.localCurrency,
                              mode: "group",
                              type: _vm.totalAmountToCurrency.type,
                              "data-provider":
                                _vm.totalAmountToCurrency.dataProvider,
                              "data-field": _vm.totalAmountToCurrency.dataField,
                              "currency-field":
                                _vm.totalAmountToCurrency.currencyField,
                              "rate-field": _vm.totalAmountToCurrency.rateField,
                              "arap-group": _vm.totalAmountToCurrency.arapGroup,
                              "ar-field": "chargeReceivable",
                              "only-show-convert": true
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.showSalePriceHc,
                          expression: "!showSalePriceHc"
                        }
                      ]
                    },
                    [
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            key: 5,
                            ref: "chargeCurrencyTotalGroup5",
                            attrs: {
                              "amount-to-currency": _vm.localCurrency,
                              "amount-to-currency-label":
                                _vm.$t("CargoMsg.Cargo_ReconciliationAmount") +
                                _vm.$t("Clearing.Equivalent"),
                              mode: "group",
                              type: _vm.totalAmountToCurrency.type,
                              "data-provider":
                                _vm.totalAmountToCurrency.dataProvider,
                              "data-field": "chargeBillingAmount",
                              "currency-field":
                                _vm.totalAmountToCurrency.currencyField,
                              "rate-field": _vm.totalAmountToCurrency.rateField,
                              "arap-group": _vm.totalAmountToCurrency.arapGroup,
                              "ar-field": "chargeReceivable",
                              "only-show-convert": true
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.showSalePriceHc,
                          expression: "!showSalePriceHc"
                        }
                      ]
                    },
                    [
                      _vm.reCalc
                        ? _c("charge-currency-total-group", {
                            key: 6,
                            ref: "chargeCurrencyTotalGroup6",
                            attrs: {
                              "amount-to-currency": _vm.localCurrency,
                              "amount-to-currency-label":
                                _vm.$t("CargoMsg.Cargo_Difference") +
                                _vm.$t("Clearing.Equivalent"),
                              mode: "group",
                              type: _vm.totalAmountToCurrency.type,
                              "data-provider":
                                _vm.totalAmountToCurrency.dataProvider,
                              "data-field": "chargeDiffAmount",
                              "currency-field":
                                _vm.totalAmountToCurrency.currencyField,
                              "rate-field": _vm.totalAmountToCurrency.rateField,
                              "arap-group": _vm.totalAmountToCurrency.arapGroup,
                              "ar-field": "chargeReceivable",
                              "only-show-convert": true
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.appendQuery,
                      expression: "appendQuery"
                    }
                  ],
                  staticClass: "pagination-container"
                },
                [
                  _c("el-pagination", {
                    staticStyle: { "text-align": "left" },
                    attrs: {
                      total: _vm.searchConditions.total,
                      layout: "total"
                    }
                  })
                ],
                1
              ),
              _vm.billType === "job" && !_vm.appendQuery
                ? _c("cargo-pagination", {
                    key: "job",
                    attrs: {
                      "config-module": "190901",
                      total: _vm.searchConditions.total,
                      page: _vm.searchConditions.pageNum,
                      limit: _vm.searchConditions.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.searchConditions, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(
                          _vm.searchConditions,
                          "pageSize",
                          $event
                        )
                      },
                      pagination: _vm.fetchDataByPage
                    }
                  })
                : _vm._e(),
              _vm.billType === "charge" && !_vm.appendQuery
                ? _c("cargo-pagination", {
                    key: "charge",
                    attrs: {
                      "config-module": "190902",
                      total: _vm.searchConditions.total,
                      page: _vm.searchConditions.pageNum,
                      limit: _vm.searchConditions.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.searchConditions, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(
                          _vm.searchConditions,
                          "pageSize",
                          $event
                        )
                      },
                      pagination: _vm.fetchDataByPage
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm.currentOptStatus === _vm.optStatusDefs.billDetailView
        ? _c("bill-detail", {
            attrs: {
              "billing-uuid": "",
              "view-billing": false,
              "r-type": _vm.billType,
              "view-source": "reconciliation",
              "new-billing": _vm.newBilling,
              "new-charges": _vm.newCharges,
              "create-bill-way": _vm.createBillWay,
              accounts: _vm.accounts,
              location: _vm.location
            },
            on: {
              cancel: _vm.cancelBilling,
              backReconciliation: _vm.backReconciliationEvent
            }
          })
        : _vm._e(),
      _vm.currentOptStatus === _vm.optStatusDefs.newBillDetailView
        ? _c("split-bill-detail", {
            attrs: {
              "billing-uuid": "",
              "view-billing": false,
              "reconciliation-type": _vm.billType,
              "view-source": "reconciliation",
              "new-billing": _vm.newBilling,
              "new-charges": _vm.newCharges,
              "customer-detail": _vm.customerDetail,
              "create-bill-way": _vm.createBillWay,
              accounts: _vm.accounts,
              location: _vm.location
            },
            on: {
              cancel: _vm.cancelBilling,
              backReconciliation: _vm.backReconciliationEvent
            }
          })
        : _vm._e(),
      _vm.writeOffDialog.visible
        ? _c("write-off-dialog", {
            ref: "dgWriteoff",
            attrs: {
              location: _vm.location,
              visible: _vm.writeOffDialog.visible,
              title: _vm.title,
              properties: _vm.properties
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.writeOffDialog, "visible", $event)
              },
              writeoffSuccessHandler: _vm.reloadData
            }
          })
        : _vm._e(),
      _c("bill-payment-dialog", {
        ref: "billPayment",
        attrs: {
          visible: _vm.showBillPaymentDialog,
          "open-sap-config": false,
          "create-submit": true,
          location: _vm.location,
          step: "step2",
          mode: "overview"
        },
        on: {
          "update:visible": function($event) {
            _vm.showBillPaymentDialog = $event
          },
          cancel: _vm.cancelBillPayment
        }
      }),
      _c("make-invoice-dialog", {
        ref: "invoice",
        attrs: { "view-source": "reconciliation", location: _vm.location },
        on: { reloadData: _vm.reloadData }
      }),
      _vm.showConflictChargeDialog
        ? _c("conflict-charges-dialog", {
            attrs: {
              visible: _vm.showConflictChargeDialog,
              charges: _vm.conflictCharges,
              "view-source": "reconciliation"
            },
            on: {
              "update:visible": function($event) {
                _vm.showConflictChargeDialog = $event
              },
              conflictChargeCallBackEventToReconciliation:
                _vm.conflictChargeCallBackEventToReconciliation
            }
          })
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.batchGenerateBillingDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_BatchCreateBillTitle"),
            "close-on-click-modal": false,
            "show-close": false,
            width: "305px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.batchGenerateBillingDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: {
                "flex-direction": "column",
                "padding-bottom": "10px"
              }
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    "text-align": "center",
                    "font-size": "14px",
                    "padding-bottom": "20px"
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BatchCreateBillBySame")))]
              ),
              _c(
                "el-radio-group",
                {
                  attrs: { no: "38" },
                  model: {
                    value: _vm.batchGenerateBillingDialog.createMode,
                    callback: function($$v) {
                      _vm.$set(
                        _vm.batchGenerateBillingDialog,
                        "createMode",
                        $$v
                      )
                    },
                    expression: "batchGenerateBillingDialog.createMode"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_BatchCreateBillByAll"))
                    )
                  ]),
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(
                      _vm._s(_vm.$t("CargoMsg.Cargo_BatchCreateBillBySelected"))
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "39" },
                  on: { click: _vm.batchGenerateBillingConfirm }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "40" },
                  on: { click: _vm.batchGenerateBillingCancel }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.batchConfirmDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_ConfirmR"),
            "close-on-click-modal": false,
            "show-close": false,
            width: "450px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.batchConfirmDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "app-main-inner-row" },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { color: "blue" },
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("CargoMsg.Cargo_ACSWASRATBTSWEAC"))
                        )
                      ])
                    ]
                  ),
                  _c("el-form-item", { attrs: { "label-width": "0" } }, [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _c("span", { staticStyle: { color: "blue" } }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_ChargeConfirmSerialNumber")
                            ) + ":"
                          )
                        ]),
                        _c("el-input", {
                          staticStyle: {
                            "padding-left": "10px",
                            width: "170px"
                          },
                          attrs: {
                            value:
                              _vm.batchConfirmDialog.confirmSerialNumber ||
                              undefined,
                            controls: false,
                            no: "41"
                          },
                          on: {
                            input: function(value) {
                              value = value ? value.replace(/[^0-9]/g, "") : ""
                              this$1.batchConfirmDialog.confirmSerialNumber =
                                value || ""
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "fit-content" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "42" },
                  on: { click: _vm.batchConfirmHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Yes")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "43" },
                  on: {
                    click: function() {
                      this$1.batchConfirmDialog.visible = false
                      this$1.batchConfirmDialog.confirmSerialNumber = ""
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_No")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.showBatchUpdateConfirmSerialNumberDialog,
            title: _vm.$t(
              "CargoMsg.Cargo_BatchUpdateChargeConfirmSerialNumber"
            ),
            "close-on-click-modal": false,
            "show-close": false,
            width: "350px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showBatchUpdateConfirmSerialNumberDialog = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: {
                "flex-direction": "column",
                "padding-bottom": "10px"
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticStyle: { color: "blue" },
                      attrs: { "label-width": "0" }
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "CargoMsg.Cargo_BatchUpdateChargeConfirmSerialNumberTip"
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { "label-width": "0" } },
                    [
                      _c("el-form-item", { attrs: { "label-width": "0" } }, [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          [
                            _c("span", { staticStyle: { color: "blue" } }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_ChargeConfirmSerialNumber"
                                  )
                                ) + ":"
                              )
                            ]),
                            _c("el-input", {
                              staticStyle: {
                                "padding-left": "10px",
                                width: "170px"
                              },
                              attrs: {
                                value: _vm.confirmSerialNumber || undefined,
                                controls: false,
                                no: "44",
                                placeholder: _vm.$t(
                                  "CargoMsg.Cargo_InputChargeConfirmSerialNumber"
                                )
                              },
                              on: {
                                input: function(value) {
                                  value = value
                                    ? value.replace(/[^0-9]/g, "")
                                    : ""
                                  this$1.confirmSerialNumber = value || ""
                                }
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticStyle: { margin: "0 auto", width: "fit-content" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "45" },
                  on: { click: _vm.batchUpdateConfirmSerialNumberHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "46" },
                  on: {
                    click: function() {
                      this$1.showBatchUpdateConfirmSerialNumberDialog = false
                      this$1.confirmSerialNumber = ""
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            "close-on-click-modal": false,
            visible: _vm.importFormDialog,
            title: _vm.dialogTitle,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.importFormDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "app-main-inner-row" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.dialogTitle ===
                      _vm.$t("Clearing.SelectImportTemplateSolution"),
                    expression:
                      "dialogTitle === $t('Clearing.SelectImportTemplateSolution')"
                  }
                ],
                staticStyle: { margin: "0 auto" }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("Clearing.TemplateSolutionName")))
                ]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "300px", "margin-left": "10px" },
                    attrs: { filterable: "", placeholder: _vm.plan },
                    model: {
                      value: _vm.solutionsValue,
                      callback: function($$v) {
                        _vm.solutionsValue = $$v
                      },
                      expression: "solutionsValue"
                    }
                  },
                  _vm._l(_vm.solutionsNameList, function(item, index) {
                    return _c("el-option", {
                      key: index,
                      attrs: { label: item.templateName, value: item.uuid }
                    })
                  }),
                  1
                ),
                _c("p", { staticStyle: { margin: "10px 0 0 82px" } }, [
                  _vm._v(
                    _vm._s(_vm.$t("Clearing.ToMaintainImportTemplatesClick")) +
                      " "
                  ),
                  _c(
                    "span",
                    {
                      staticStyle: { color: "#4283ff", cursor: "pointer" },
                      on: { click: _vm.jump }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("Clearing.BasicDataImportTemplateSolutions")
                        )
                      )
                    ]
                  )
                ])
              ],
              1
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.dialogTitle === _vm.$t("Clearing.Prompt"),
                    expression: "dialogTitle === $t('Clearing.Prompt')"
                  }
                ],
                staticStyle: { margin: "0 auto" }
              },
              [
                _c("span", [
                  _vm._v(
                    "导入成功" +
                      _vm._s(_vm.successOrFailure.succeed) +
                      "条，导入失败" +
                      _vm._s(_vm.successOrFailure.failure) +
                      "条，是否下载导入失败的文件？"
                  )
                ])
              ]
            )
          ]),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-upload",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.dialogTitle ===
                          _vm.$t("Clearing.SelectImportTemplateSolution") &&
                        _vm.solutionsValue,
                      expression:
                        "dialogTitle === $t('Clearing.SelectImportTemplateSolution') && solutionsValue"
                    }
                  ],
                  staticStyle: {
                    display: "inline-block",
                    "padding-left": "5px"
                  },
                  attrs: {
                    action: "string",
                    "http-request": _vm.importExcelEventHandler,
                    "show-file-list": false,
                    accept: ".xls, .xlsx",
                    "before-upload": _vm.beforeUploadUsage
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "47", size: "mini" },
                      on: { click: _vm.theImport }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
                  )
                ],
                1
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.solutionsValue,
                      expression: "!solutionsValue"
                    }
                  ],
                  attrs: { type: "primary", no: "48", size: "mini" },
                  on: { click: _vm.theImport }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.dialogTitle === _vm.$t("Clearing.Prompt"),
                      expression: "dialogTitle === $t('Clearing.Prompt')"
                    }
                  ],
                  attrs: { type: "primary", no: "49", size: "mini" },
                  on: { click: _vm.download }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", no: "50" },
                  on: {
                    click: function($event) {
                      _vm.importFormDialog = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.showChargeCheckDialog
        ? _c("charge-check-dialog", {
            attrs: {
              visible: _vm.showChargeCheckDialog,
              info: {
                title: _vm.$t("CargoMsg.Cargo_EditFinancialDate"),
                label: _vm.$t("CargoMsg.Cargo_FinancialDate")
              }
            },
            on: {
              "update:visible": function($event) {
                _vm.showChargeCheckDialog = $event
              },
              confirm: function($event) {
                return _vm.chargeAuditConfirmCB($event)
              }
            }
          })
        : _vm._e(),
      _c("batch-upload-file", {
        attrs: {
          visible: _vm.cloudFile.visible,
          "redis-key": _vm.cloudFile.redisKey,
          "job-num": _vm.cloudFile.num,
          "page-source": "tabReconciliation",
          lob: _vm.cloudFile.lob
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.cloudFile, "visible", $event)
          }
        }
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.financialRemarksFormDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_FinancialRemarks"),
            "close-on-click-modal": false,
            "show-close": false,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.financialRemarksFormDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: {
                "flex-direction": "column",
                "padding-bottom": "10px"
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "80px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_FinancialRemarks")
                      }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          maxlength: "512",
                          "show-word-limit": ""
                        },
                        model: {
                          value: _vm.financialRemarksFormDialog.remarks,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.financialRemarksFormDialog,
                              "remarks",
                              $$v
                            )
                          },
                          expression: "financialRemarksFormDialog.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    color: "#999",
                    "font-size": "12px",
                    "margin-top": "10px"
                  }
                },
                [_vm._v(" " + _vm._s(_vm.$t("Billing.WarmPromptAppend")) + " ")]
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveFinancialRemarks }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c("el-button", { on: { click: _vm.cancelFinancialRemarks } }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))
              ])
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.confirmationLetterRemarksFormDialog.visible,
            title: _vm.$t("Billing.InquiryLetterRemark"),
            "close-on-click-modal": false,
            "show-close": false,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(
                _vm.confirmationLetterRemarksFormDialog,
                "visible",
                $event
              )
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: {
                "flex-direction": "column",
                "padding-bottom": "10px"
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "80px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Billing.InquiryLetterRemark") } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 3,
                          maxlength: "512",
                          "show-word-limit": ""
                        },
                        model: {
                          value:
                            _vm.confirmationLetterRemarksFormDialog.remarks,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.confirmationLetterRemarksFormDialog,
                              "remarks",
                              $$v
                            )
                          },
                          expression:
                            "confirmationLetterRemarksFormDialog.remarks"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: {
                    color: "#999",
                    "font-size": "12px",
                    "margin-top": "10px"
                  }
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("Billing.WarmPromptOverwrite")) + " "
                  )
                ]
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveConfirmationLetterRemarks }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Save")))]
              ),
              _c(
                "el-button",
                { on: { click: _vm.cancelConfirmationLetterRemarks } },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("change-account-id-dialog", {
        attrs: {
          visible: _vm.changeAccountIdDialog.visible,
          "is-ar": _vm.changeAccountIdDialog.isAr,
          "company-factory-signs":
            _vm.changeAccountIdDialog.companyFactorySigns,
          "default-account-id": 0,
          required: true,
          "show-before-after": _vm.changeAccountIdDialog.showBeforeAfter,
          "before-account-id": _vm.changeAccountIdDialog.beforeAccountId,
          "settlement-active-only": false
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.changeAccountIdDialog, "visible", $event)
          },
          changeAccountId: _vm.onBatchChangeAccountIdConfirm
        }
      }),
      _c("change-invoice-title-dialog", {
        attrs: {
          visible: _vm.changeInvoiceTitleDialog.visible,
          "account-id": _vm.changeInvoiceTitleDialog.accountId,
          "default-invoice-title":
            _vm.changeInvoiceTitleDialog.defaultInvoiceTitle,
          required: true,
          "show-before-after": _vm.changeInvoiceTitleDialog.showBeforeAfter,
          "before-invoice-title":
            _vm.changeInvoiceTitleDialog.beforeInvoiceTitle
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.changeInvoiceTitleDialog, "visible", $event)
          },
          changeInvoiceTitle: _vm.onBatchChangeInvoiceTitleConfirm
        }
      }),
      _vm.invoicePoolDialog.visible
        ? _c("invoice-pool-dialog", {
            attrs: {
              visible: _vm.invoicePoolDialog.visible,
              "seller-tax-name-default-value":
                _vm.invoicePoolDialog.sellerTaxNameDefaultValue,
              "selected-entities": _vm.invoicePoolDialog.selectedEntities,
              "make-invoice-method": _vm.invoicePoolDialog.makeInvoiceMethod,
              operation: _vm.invoicePoolDialog.operation,
              source: _vm.invoicePoolDialog.source
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.invoicePoolDialog, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }